const protocol  = 'https://';
const rootURI = 'creditkey.com';

export const VERSION = '1.0.0';

const isStaging = window.location && (window.location.hostname.match(/staging/i) || window.location.hostname.match(/amplifyapp/i));

export const platform = () => {
  if (process.env.NODE_ENV !== 'production') {
    return 'development';
  } else if (isStaging) {
    return 'staging'
  }

  return 'production';
}

export const applyUI = () => {
  switch(platform()) {
    case 'development':
      return 'http://apply.localhost:3001';
    case 'staging':
      return 'https://staging-apply.creditkey.com';
    case 'production':
      return 'https://apply.creditkey.com';
  }
}

export const defaultMerchant = () => {
  switch (platform()) {
    case 'development' :
      return 'creditkeydev_2822baea77774929979f1e5964dd18b6';
      break;
    case 'staging' :
      return 'creditkeytest_6d8e5758033846b4995993dd74dda57c';
      break;
    case 'production' :
      return 'creditkeysamplestore_2d3170af046347cdaf0171e06c08ca77';
      break;
  }

}

export const server = (api = true) => {
  if (process.env && process.env.NODE_ENV !== 'production') return 'http://localhost:9100';

  let subDomain = 'www';
  if (isStaging) subDomain = 'staging';

  const baseURI = protocol + subDomain + '.' + rootURI;

  return api ? `${baseURI}/app` : baseURI;
}

export const applyNowKeys = [
  'culinarydepotinc_528684039fb344feb020d13ba49ab8f7', // culinarydepot production
  'culinarydepotinc_634edba3db5c47ce81926db4b7a69f77', // culinarydepot staging
  'creditkeydev_2822baea77774929979f1e5964dd18b6' // local dev
];

export const loadApplyNow = publicKey => {
  return window.open(
    applyUI() + '/' + publicKey,
    '_blank'
  );
}

export const borrowerPortalUrl = () => `${server()}/dashboard/borrower`;

export const dateFormat = 'YYYY-MM-DD HH:MM:SSZ';

export const validationStyles = "has-text-danger has-text-left has-text-weight-semibold is-size-7 mt-1 mb-3";

export const supportPhone =  '+1 (844) 334-3636';

export const suffixes = [
  "",
  "Jr",
  "Sr",
  "II",
  "III",
  "IV",
  "V",
  "DDM",
  "DDS",
  "DO",
  "ESQ",
  "MD",
  "RN"
]

export const business_types = [
  ["", ""],
  ["Corporation", "Corporation"],
  ["LLC", "LLC"],
  ["Sole Proprietorship", "Sole Proprietorship"],
  ["Partnership", "Partnership"],
  ["Nonprofit corporation", "Nonprofit corporation"],
  ["Federal", "Federal"],
  ["Municipal", "Municipal"],
]

export const states = [
  ["", ""],
  ["Alabama", "AL"],
  ["Alaska", "AK"],
  ["Arizona", "AZ"],
  ["Arkansas", "AR"],
  ["California", "CA"],
  ["Colorado", "CO"],
  ["Connecticut", "CT"],
  ["Delaware", "DE"],
  ["Florida", "FL"],
  ["Georgia", "GA"],
  ["Hawaii", "HI"],
  ["Idaho", "ID"],
  ["Illinois", "IL"],
  ["Indiana", "IN"],
  ["Iowa", "IA"],
  ["Kansas", "KS"],
  ["Kentucky", "KY"],
  ["Louisiana", "LA"],
  ["Maine", "ME"],
  ["Maryland", "MD"],
  ["Massachusetts", "MA"],
  ["Michigan", "MI"],
  ["Minnesota", "MN"],
  ["Mississippi", "MS"],
  ["Missouri", "MO"],
  ["Montana", "MT"],
  ["Nebraska", "NE"],
  ["Nevada", "NV"],
  ["New Hampshire", "NH"],
  ["New Jersey", "NJ"],
  ["New Mexico", "NM"],
  ["New York", "NY"],
  ["North Carolina", "NC"],
  ["North Dakota", "ND"],
  ["Ohio", "OH"],
  ["Oklahoma", "OK"],
  ["Oregon", "OR"],
  ["Pennsylvania", "PA"],
  ["Rhode Island", "RI"],
  ["South Carolina", "SC"],
  ["South Dakota", "SD"],
  ["Tennessee", "TN"],
  ["Texas", "TX"],
  ["Utah", "UT"],
  ["Vermont", "VT"],
  ["Virginia", "VA"],
  ["Washington", "WA"],
  ["Washington DC", "DC"],
  ["West Virginia", "WV"],
  ["Wisconsin", "WI"],
  ["Wyoming", "WY"],
]

export const emailRegex = /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/ 
